import React, { Fragment } from 'react'

const EmailSignature = ({ user}) => {
    return (
        <div>
            <br />
            <br />
            <p>Best regards,</p>
            <p>
                <strong>{user.full_name}</strong><br />
                {user.designation}<br />
                {user.email && <Fragment>Email: <a href={`mailto:${user.email}`}>{user.email}</a></Fragment>}<br />
                {user.contact_number && <Fragment>Mobile: <a href={`tel:91${user.contact_number}`}>+91-{user.contact_number}</a></Fragment>}<br />
            </p>
        </div>
    )
}

export default EmailSignature